<template>
    <div class="schedule">
        <div class="schedule-head">
            <div class="schedule-head-left">
                <span @click="getToday">今日</span>
                <span class="arrow" @click="leftBack">
                    <img :src="require('@/assets/Home/Index/left-arrow.png')"/>
                </span>
            </div>
            <div class="schedule-head-date" :class="active === index ? 'active' : ''" v-for="(item,index) in headData" :key="index" @click="chooseDate(item,index)">
                <span>{{item.date}}</span>
                <span>{{item.weekName}}</span>
            </div>
            <div class="schedule-head-right">
                <span @click="scheduleJump">全部</span>
                <span class="arrow" @click="rightForward">
                    <img :src="require('@/assets/Home/Index/right-arrow.png')"/>
                </span>
            </div>

        </div>
        <div class="schedule-content">
            <div class="schedule-content-title">
                <span>{{dayAndWeek}}</span>
                <span @click="addSchedule" v-if="scheduleList.length > 0"> <img :src="require('@/assets/Home/Index/add-schedule.png')"/></span>
            </div>
            <div class="schedule-content-main" v-loading="loading" >
                <div class="schedule-content-main-shedule" v-if="scheduleList.length > 0" v-for="(item,index) in scheduleList" :key="index" :style="{'backgroundColor':item.bgColor}">
                    <div class="schedule-content-main-shedule-spot" :style="{'backgroundColor':item.color}"></div>
                    <div class="schedule-content-main-shedule-main">
                        <p class="name">{{item.title}}</p>
                        <p class="address"><i class="el-icon-location-outline"></i> <span class="oneRowEllipsis arressInfo">{{item.address || '-'}}</span></p>
                    </div>
                    <div class="schedule-content-main-shedule-time" v-if="item.isWholeDay !== '1'">
                        {{item.startTime && item.startTime.substring(0,5)}}-{{item.endTime && item.endTime.substring(0,5)}}
                    </div>
                    <div class="schedule-content-main-shedule-time" v-if="item.isWholeDay === '1'">
                        全天
                    </div>
                </div>
            </div>

            <div class="no-data" v-if="scheduleList.length === 0 && !loading">
                <img :src="require('@/assets/Common/no-data.png')"/>
                <el-button type="primary" round @click="addSchedule">去添加日程</el-button>
            </div>

        </div>
      <el-drawer
        append-to-body
        :visible.sync="addScheduleVisible"
        size="740px"
        title="添加日程"
      >
        <AddSchedule :visible="addScheduleVisible" @closeDrawer="closeDrawer"/>
      </el-drawer>

    </div>
</template>

<script>
    import { getScheduleList,getWeekInfo } from '@/api/calendar';
    import AddSchedule from "@/views/Home/Modules/AddSchedule/AddSchedule"
    export default {
        name: "Schedule",
        data(){
            return {
                headData:[
                ],
                loading:false,
                scheduleList:[],
                timestamp: (new Date()).getTime(),
                oneDay: 86400000,
                active:0,
                dayAndWeek:'',
                colorArr : [{color:"rgba(244, 187, 188, 1)", bgColor:"rgba(244, 187, 188, 0.14)"},{color:"rgba(150, 144, 213, 1)", bgColor:"rgba(150, 144, 213, 0.14)"},
                    {color:"rgba(253, 186, 46, 1)", bgColor:"rgba(253, 186, 46, 0.14)"},{color:"rgba(86, 200, 236, 1)", bgColor:"rgba(86, 200, 236, 0.14)"},
                    {color:"rgba(63, 193, 167, 1)", bgColor:"rgba(63, 193, 167, 0.14)"}],
              addScheduleVisible: false  // 新增日程显示因此变量
            }
        },
        created(){
            this.getToday();
        },
      components: {
        AddSchedule
      },
        methods: {
          closeDrawer(status){
            this.addScheduleVisible = false;
            if (status === 'save') this.getToday();
          },
          // 添加日程
          addSchedule(){
            this.addScheduleVisible = true;
          },
            chooseDate(item,index) {
                this.active = index;
              this.getWeekInfo(item)
                this.getScheduleList();
            },
            rightForward(){
                let timest = this.headData[6].timestamp + this.oneDay;
                this.headData = this.returnWeek(timest);
                this.active = 0;
                let chooseDate = this.headData[this.active];
              this.getWeekInfo(chooseDate)
                this.getScheduleList()
            },
            leftBack(){
                let timest = this.headData[0].timestamp - this.oneDay;
                this.headData = this.returnWeek(timest);
                this.active = 0;
                let chooseDate = this.headData[this.active];
              this.getWeekInfo(chooseDate)
                this.getScheduleList()
            },
            scheduleJump(){
            // 单条日程暂时不跳转
                const { href } = this.$router.resolve({
                    name: "ScheduleCenter"
                });
                window.open(href);

            },
            getToday() {
              this.headData = this.returnWeek(this.timestamp);
              let choosedDay = this.headData[this.active];
                this.getWeekInfo(choosedDay);
                this.getScheduleList();
            },
          async getWeekInfo(choosedDay){
            let teachingWeek,semester = '';
            let res = await getWeekInfo({today:`${choosedDay.year}-${choosedDay.month}-${choosedDay.date}`})
            if(res.code === 0 && res.data) {
             if(res.data.data.date && res.data.data.date.length > 0) {
               teachingWeek = `第${res.data.data.date[0]}教学周`
             }
             if(res.data.data && res.data.data.semester) {
               semester = res.data.data.semesterAli || ''
             }
            }

            this.dayAndWeek = `${choosedDay.year}-${choosedDay.month}-${choosedDay.date} ${semester} ${teachingWeek} 周${choosedDay.weekName}`
          },
            async getScheduleList(){
                let chooseDate = this.headData[this.active];
                let reqDate = `${chooseDate.year}-${chooseDate.month}-${chooseDate.date}`
                let param = {
                    startDate:reqDate,
                    endDate:reqDate,
                    reqType: 'DateView'
                }
                this.loading = true;
                try{
                    let res = await getScheduleList(param);
                    this.loading = false;
                    if(res.code !== 0) {
                        this.$message.error('请求日程错误!');
                        return;
                    }
                    this.scheduleList = res.data && res.data.schedule && res.data.schedule[reqDate] && res.data.schedule[reqDate].calendarList || [];
                    this.scheduleList.forEach((item,index)=> {
                        item.color = this.colorArr[index % this.colorArr.length].color;
                        item.bgColor = this.colorArr[index % this.colorArr.length].bgColor;

                    })

                }catch(e){
                    this.loading = false;
                    this.$message.error('请求日程错误!');
                    return;
                }

            },
            // 计算周试图title显示内容
            returnWeek(value) {
                let date = new Date(value);
                let w = date.getDay();
                let weekName = ["日", "一", "二", "三", "四", "五", "六"];
                let dispanceDayS;
                let dispanceDaywW;
                let arr = [];
                w = w === 0 ? 7 : w;
                dispanceDayS = w - 1;
                this.active = dispanceDayS;
                dispanceDaywW = 7 - w;
                let a = dispanceDayS;
                while(a >= 0 && a <= dispanceDayS) {
                    let obj = {}
                    let oneS = new Date(value).getTime() - a * this.oneDay;
                    obj.timestamp = oneS;
                    let dates = new Date(oneS);
                    let ys = dates.getFullYear(); // 1970 - ????
                    let ms = dates.getMonth() + 1; // 0 - 11
                    let ds = dates.getDate(); // 0 - 11
                    ms = ms < 10 ? "0" + ms : ms;
                    ds = ds < 10 ? "0" + ds : ds;
                    obj.year = ys;
                    obj.month = ms;
                    obj.date = ds;
                    obj.weekVal = dates.getDay();
                    obj.weekName = weekName[obj.weekVal]
                    arr.push(obj);
                    a--
                }
                a = 1;
                while(a <= dispanceDaywW) {
                    let obj = {}
                    let oneS = new Date(value).getTime() + a * this.oneDay;
                    obj.timestamp = oneS;
                    let dates = new Date(oneS);
                    let ys = dates.getFullYear(); // 1970 - ????
                    let ms = dates.getMonth() + 1; // 0 - 11
                    let ds = dates.getDate(); // 0 - 11
                    ms = ms < 10 ? "0" + ms : ms;
                    ds = ds < 10 ? "0" + ds : ds;
                    obj.weekVal = dates.getDay();
                    obj.weekName = weekName[obj.weekVal]
                    obj.year = ys;
                    obj.month = ms;
                    obj.date = ds;
                    arr.push(obj);
                    a++
                }
                return arr;
            },
        }

    }
</script>

<style scoped lang="scss">
    @import '@/styles/variables.scss';
    .schedule {
        border-top: 4px solid $color-primary;
        width: 100%;
        height: 100%;
        background-color: white;
        border-bottom: 2px solid $color-primary;
        span {
            display: inline-block;
        }
        &-head {
            padding-top: 16px;
            padding-left: 21px;
            padding-right: 21px;
            font-size: 14px;
            display: flex;
            &-left,&-date,&-right {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 63px;
                cursor: pointer;
                span:first-child {
                    color:#959DB1;
                }
                span:nth-child(2) {
                    color:#333333;
                }
            }
            &-left {
                margin-right: 20px;
                min-width: 31px;
            }
            &-date {

                width: 38px;
                text-align: center;

            }
            &-date.active {
                background-color: $color-primary;
                border-radius: 19px;
                > span {
                    color: white
                }

            }
            &-right {
                margin-left: 20px;
                min-width: 31px;

            }
            .arrow {
                width: 26px;
                height: 26px;
                display: inline-block;
                img {
                    width: 100%;
                    height: 100%;
                }
            }

        }
        &-content {
            margin-top: 28px;
            display: flex;
            height: calc(100% - 108px);
            flex-direction: column;
            position: relative;
            &-title {
                font-size: 16px;
                color: #333333;
                font-weight: 400;
                padding: 0 22px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 7px;
                 img {
                    width: 22px;
                     height: 22px;
                     cursor: pointer;
                }

            }
            &-main {
                height: calc(100% - 30px);
                display: flex;
                overflow-y: auto;
                flex-direction: column;
                padding-bottom: 6px;
                &-shedule {
                    margin: 0 20px;
                    background-color: rgba(244, 187, 188, 0.14);
                    display: flex;
                    align-items: center;
                    padding-right: 15px;
                    border-radius: 4px;
                    margin-top: 15px;

                    &-spot {
                        width:7px;
                        height: 100%;
                        border-radius: 4px;
                        margin-right: 15px;
                        background-color: rgba(244, 187, 188, 1);
                    }
                    &-main {
                        font-size: 14px;
                        display: flex;
                        flex-direction: column;
                        line-height: 20px;
                        width: calc(100% - 120px);
                        padding:10px 0;
                        .name {
                            color: #333333;
                            width:100%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow:ellipsis ;
                        }
                        .address {
                            display: flex;
                            align-items: center;
                            color:#8D8E95;
                            i {
                                font-size: 14px;
                                margin-right: 5px;
                            }
                          .arressInfo {
                            width: calc(100% - 19px);
                          }

                        }

                    }
                    &-time {
                        font-size: 16px;
                        color:#ADB6CC;
                        width: 100px;
                        text-align: right;
                    }
                }

            }

            .no-data {
                text-align: center;
                position: absolute;
                left: 50%;
                top:50%;
                transform: translate(-50%,-50%);
                img {
                    width: 230px;
                    display: inline-block;
                }
                .el-button.is-round {
                    padding: 8px 21px;
                    margin-top: 10px;
                    background-color: $color-primary;
                    border-color: $color-primary;
                }
            }
        }

    }
    @media (max-width: 1719px){
        .schedule {
            &-head {
                padding-left: 8px;
                padding-right: 8px;
                &-left {
                    margin-right: 8px;
                }
                &-right {
                    margin-left: 8px;

                }
            }
        }

    }

</style>